import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const siteService = {
  add_site_data,
  check_userName,
  check_siteName,
  check_userEmail,
  get_SiteList,
  get_SitepaidList,
  get_SiteInactiveList,
  getSiteDetailsBySiteId,
  update_site_data,
  delete_site_data,
  update_status,
  check_site_domain,
  get_city_geoLocation,
  getDashobardData,
  getPaidDashobardData,
  getCustomerData,
  subDomain,
  deleteDomain,
  installssl,
};

function getCustomerData(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData),
  };
  return fetch(`${appConfig.api.url}superadmin/search`, requestOptions)
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}

function getDashobardData(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData),
  };
  return fetch(`${appConfig.api.url}superadmin/dashboard`, requestOptions)
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}

function getPaidDashobardData(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData),
  };
  return fetch(`${appConfig.api.url}superadmin/invoiceddashboard`, requestOptions)
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}


function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
  }
}

function add_site_data(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData),
  };

  return fetch(`${appConfig.api.url}site/add`, requestOptions)
    .then(handleResponse)
    .then((sitedata) => {
      return sitedata;
    });
}

function update_site_data(propsData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData),
  };

  return fetch(`${appConfig.api.url}site/edit`, requestOptions)
    .then(handleResponse)
    .then((updatesite) => {
      return updatesite;
    });
}

function update_status(propsData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(propsData),
  };
  if (propsData && propsData.siteID !== "" && propsData.status !== "") {
    return fetch(`${appConfig.api.url}site/status`, requestOptions)
      .then(handleResponse)
      .then((updatestatus) => {
        return updatestatus;
      });
  }
}

function delete_site_data(siteID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}site/delete/${siteID}`, requestOptions)
    .then(handleResponse)
    .then((site) => {
      return site;
    });
}

function check_userName(propsdata) {
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ userName: propsdata }),
  };

  return fetch(`${appConfig.api.url}check_username`, requestOptions)
    .then(handleResponse)
    .then((message) => {
      return message;
    });
}

function check_siteName(propsdata) {
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ siteName: propsdata }),
  };

  return fetch(`${appConfig.api.url}check_site_name`, requestOptions)
    .then(handleResponse)
    .then((message) => {
      return message;
    });
}

function check_userEmail(propsEmail) {
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ email: propsEmail }),
  };

  return fetch(`${appConfig.api.url}check_email`, requestOptions)
    .then(handleResponse)
    .then((emailResponse) => {
      return emailResponse;
    });
}

function get_SiteList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page),
  };

  return fetch(`${appConfig.api.url}site/list`, requestOptions)
    .then(handleResponse)
    .then((sitelist) => {
      return sitelist;
    });
}

function get_SitepaidList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page),
  };

  return fetch(`${appConfig.api.url}site/paidlist`, requestOptions)
    .then(handleResponse)
    .then((sitelist) => {
      return sitelist;
    });
}

function get_SiteInactiveList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page),
  };

  return fetch(`${appConfig.api.url}site/inactive-list`, requestOptions)
    .then(handleResponse)
    .then((sitelist) => {
      return sitelist;
    });
}

function getSiteDetailsBySiteId(siteID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
  };

  return fetch(`${appConfig.api.url}site/detail/${siteID}`, requestOptions)
    .then(handleResponse)
    .then((sitedatabyId) => {
      return sitedatabyId;
    });
}

function check_site_domain(siteDomainData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ siteDomain: siteDomainData }),
  };

  return fetch(`${appConfig.api.url}check_site`, requestOptions)
    .then(handleResponse)
    .then((siteDomainProps) => {
      return siteDomainProps;
    });
}
function get_city_geoLocation(cityID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}city/lat-long/${cityID}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function subDomain(formData, method, url) {
  refineHeader();
  const requestOptions = {
    method: method,
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData),
  };
  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}

function deleteDomain(childSiteID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
  };
  return fetch(
    `${appConfig.api.url}site/delete-child/${childSiteID}`,
    requestOptions
  )
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}

function installssl(formData, method, url) {
  refineHeader();
  const requestOptions = {
    method: method,
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData),
  };
  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then((responseData) => {
      return responseData;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/siteService.js